import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { PaymentsClient } from "../../parentApi";

const client = new PaymentsClient(app_uri, axiosClient());

export default client;
